import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

export const fetchWorkspaces = createAsyncThunk('workspace/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/api/workspace');
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const createWorkspace = createAsyncThunk('workspace/create', async (name, { rejectWithValue }) => {
  try {
    const response = await api.post('/api/workspace', { name });
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const workspaceSlice = createSlice({
  name: 'workspace',
  initialState: {
    workspaces: [],
    activeWorkspace: (() => {
      try {
        const stored = localStorage.getItem('activeWorkspace');
        return stored ? JSON.parse(stored) : null;
      } catch {
        return null;
      }
    })(),
    loading: false,
    error: null,
    workspaceVersion: 0,
  },
  reducers: {
    setActiveWorkspace: (state, action) => {
      state.activeWorkspace = action.payload;
      localStorage.setItem('activeWorkspace', JSON.stringify(action.payload));
      state.workspaceVersion += 1;
    },
    clearWorkspace: (state) => {
      state.activeWorkspace = null;
      state.workspaces = [];
      localStorage.removeItem('activeWorkspace');
      state.workspaceVersion = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkspaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkspaces.fulfilled, (state, action) => {
        state.workspaces = action.payload;
        state.loading = false;
        
        // Validation: If we have an active workspace, ensure it still exists in the fetched list
        if (state.activeWorkspace) {
          const stillExists = action.payload.find(ws => ws._id === state.activeWorkspace._id);
          if (!stillExists) {
            console.warn('Current active workspace no longer exists. Resetting.');
            state.activeWorkspace = action.payload.length > 0 ? action.payload[0] : null;
            if (state.activeWorkspace) {
              localStorage.setItem('activeWorkspace', JSON.stringify(state.activeWorkspace));
            } else {
              localStorage.removeItem('activeWorkspace');
            }
            state.workspaceVersion += 1;
          }
        } else if (action.payload.length > 0) {
          // Default if none set
          state.activeWorkspace = action.payload[0];
          localStorage.setItem('activeWorkspace', JSON.stringify(action.payload[0]));
          state.workspaceVersion += 1;
        }
      })
      .addCase(fetchWorkspaces.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(createWorkspace.pending, (state) => {
        state.loading = true;
      })
      .addCase(createWorkspace.fulfilled, (state, action) => {
        state.workspaces.push(action.payload);
        state.activeWorkspace = action.payload;
        localStorage.setItem('activeWorkspace', JSON.stringify(action.payload));
        state.loading = false;
        state.workspaceVersion += 1;
      })
      .addCase(createWorkspace.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { setActiveWorkspace, clearWorkspace } = workspaceSlice.actions;
export default workspaceSlice.reducer;
